import React from 'react'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { Trans } from '../../atoms'
import { Breadcrumbs } from '../../molecules'
import FormTailorMade from '../../organisms/FormTailorMade/FormTailorMade'
import { getAltText } from '../../../utils/safe'

const TailorMadeTemplate = ({ page }) => {
  const { width } = useWindowDimensions()

  return (
    <div
      className="tailor-made"
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          justifySelf: 'center',
          alignSelf: 'center',
          width: '80%',
          marginTop: 50,
        }}
      >
        <Breadcrumbs breadcrumbs={page?.breadcrumbs} />
        <h2 style={{ textAlign: 'left' }}>
          <Trans chiave="Ordini import - Articoli Tailor Made" />
        </h2>
      </div>
      <img
        src={page.main_image?.url}
        style={{ width: '100%', maxHeight: 300, margin: '20px 0px' }}
        alt={getAltText(page.main_image)}
      />
      <div style={{ justifySelf: 'center', width: width > 600 ? '50%' : '80%' }}>
        <div dangerouslySetInnerHTML={{ __html: page?.descrizione }} />
        <FormTailorMade />
      </div>
    </div>
  )
}

export default TailorMadeTemplate
